import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

import style from '../styles/chapter-navi.scss';

class ChapterNavi extends React.Component{

	constructor(props){
		super(props);
	}

	render(){
		{/*/blossom*/}
		return ( 
			<div className="flex-box chapter-navi-holder">
				<div className="chapter-navi-holder-inner">
					<Link to={"/"+ _assets.root + "/chapter1"} className="chapter-link" activeClassName="chapter-active">1</Link>
					<Link to={"/"+ _assets.root + "/chapter2"} className="chapter-link" activeClassName="chapter-active">2</Link>
					<Link to={"/"+ _assets.root + "/chapter3"} className="chapter-link" activeClassName="chapter-active">3</Link>
				</div>
			</div>)
	}

}

export default ChapterNavi;


// WEBPACK FOOTER //
// ./src/scripts/chapter_navi.js